import {
  INTERNAL_GRADE_LABEL_TO_KEY,
  INTERNAL_GRADE_META,
} from "../constants/AppConstants";

export const getInternalGradeMetaFromLabel = (label?: string | null) =>
  label ? INTERNAL_GRADE_META[INTERNAL_GRADE_LABEL_TO_KEY[label]] : undefined;
